export default __webpack_public_path__ + "static/media/grafema_ummi_23.6e0ae67b.jpg";